module.exports = __webpack_public_path__ + "static/img/about_bg.324a3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/about/imgs/about_bg.png
// module id = Gizm
// module chunks = 1